import React, { useEffect, useState } from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './App.css'
import Layout from './Components/Layout/Layout';
import Home from './Components/Home/Home';
import Cart from './Components/Cart/Cart';
import "react-bootstrap-typeahead/css/Typeahead.css";
import AllProducts from './Components/AllProducts/AllProducts';
import ProductDetails from './Components/ProductDetails/ProductDetails';
import Categories from './Components/Categories/Categories';
import Brands from './Components/Brands/Brands';
import Login from './Components/Login/Login';
import Register from './Components/Register/Register';
import NotFound from './Components/NotFound/NotFound';
import BrandDetails from './Components/BrandDetails/BrandDetails';
import CategoryDetails from './Components/CategoryDetails/CategoryDetails';
import jwtDecode from 'jwt-decode';
import Profile from './Components/Profile/Profile';
import ProtectedRoute from './Components/ProtectedRoute/ProtectedRoute';
import { CartContextProvider } from './Context/CartContext';
import ForgetPassword from './Components/ForgetPassword/ForgetPassword';
import ResetPassword from './Components/ResetPassword/ResetPassword';
import Payment from './Components/Payment/Payment';
import AllOrders from './Components/AllOrders/AllOrders';
import WishList from './Components/WishList/WishList';



export default function App() {
  const [userData, setuserData] = useState(null)
  const [userDataName, setuserDataName] = useState(null)
  function saveUserData() {
    let encodeToken = localStorage.token
    let decodeToken = jwtDecode(encodeToken)
    setuserData(decodeToken)
    setuserDataName(decodeToken.name)
  }
  
  useEffect(()=> {
    if (localStorage.getItem('token') !== null && userData === null) {
      saveUserData()
    }
  }, [])

  let router =  createBrowserRouter([{path:'', element: <Layout userData={userData} setuserData= {setuserData} userDataName = {userDataName} />, children: [
    {path: '', element: <Home userData = {userData} setuserData= {setuserData}/>},
    {path: 'cart', element: <ProtectedRoute><Cart/></ProtectedRoute>},
    {path: 'wishlist', element: <ProtectedRoute><WishList/></ProtectedRoute>},
    {path: 'payment', element: <ProtectedRoute><Payment/></ProtectedRoute>},
    {path: 'allorders', element: <ProtectedRoute><AllOrders userData ={userData}/></ProtectedRoute>},
    {path: 'profile', element: <ProtectedRoute><Profile userData = {userData} setuserData= {setuserData} userDataName = {userDataName} setuserDataName= {setuserDataName}/></ProtectedRoute>},
    {path: 'forgetPassword', element: <ForgetPassword/>},
    {path: 'resetPassword', element: <ResetPassword/>},
    {path: 'products', element: <AllProducts userData = {userData}/>},
    {path: 'productdetails/:id', element: <ProductDetails userData = {userData}/>},
    {path: 'categories', element: <Categories/>},
    {path: 'categorydetails/:id', element: <CategoryDetails userData = {userData}/>},
    {path: 'brands', element: <Brands/>},
    {path: 'branddetails/:id', element: <BrandDetails userData = {userData}/>},
    {path: 'login', element: <Login saveUserData ={saveUserData}/>},
    {path: 'register', element: <Register/>},
    {path: '*',element: <NotFound/>}
  ] }])
  return (
    <>
    <CartContextProvider>
    <RouterProvider router={router}/>
    </CartContextProvider>
    
    </>
  )
}
